<template>
  <TableGradient
      icon-name="clock"
      :title="$t('tuevs.time.listagem.titulo_pagina')"
      :text-empty="$t('tuevs.time.listagem.table.empty')"
      route-new="tuevs.time.create"
      :text-new="$t('tuevs.time.listagem.novo')"
      :fields="fields"
      :items="times"
      :loading="isLoading"
      :paginator="pagination"
      @list="evt => $store.dispatch('tuevs/time/listAll', evt)"
  >
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tuevs.time.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tuevs.time.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'tuevs.time.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('tuevs.time.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/time/isLoading',
      times: 'tuevs/time/all',
      pagination: 'tuevs/time/pagination'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('tuevs.time.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tuevs.time.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tuevs.time.listagem.table.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/time/listAll'
    ])
  },
  mounted() {
    this['tuevs/time/listAll'](this.pagination)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
